__turbopack_context__.v({
  "circle": "ConcentricLoader-module__-YJByG__circle",
  "container": "ConcentricLoader-module__-YJByG__container",
  "rotate": "ConcentricLoader-module__-YJByG__rotate",
});
